import { LotDurationType } from '../../../types/lot.interface'

export const getLotDurationType = (pathname: string): LotDurationType | undefined => {
    if (pathname.includes(LotDurationType.SHORT)) {
        return LotDurationType.SHORT
    }
    if (pathname.includes(LotDurationType.LONG)) {
        return LotDurationType.LONG
    }
    if (pathname.includes(LotDurationType.NIGHT)) {
        return LotDurationType.NIGHT
    }
    if (pathname.includes(LotDurationType.SUBSCRIPTION)) {
        return LotDurationType.SUBSCRIPTION
    }
    return undefined
}
